var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Annexure")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Annexure List"
    },
    on: {
      "click": _vm.showCreateAnnexure
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Annexure Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-certificate'  style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annexurename),
      expression: "annexurename"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('annexurename')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Annexure Name",
      "id": "annexurename",
      "name": "annexurename",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.annexurename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.annexurename = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('annexurename')),
      expression: "errors.has('annexurename')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter annexure name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Annexure Description")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annexurDescription),
      expression: "annexurDescription"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "annexurDescription",
      "name": "annexurDescription"
    },
    domProps: {
      "value": (_vm.annexurDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.annexurDescription = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 5px 0px"
    },
    attrs: {
      "for": "uploadAnnexure"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("  Click to Upload Annexure")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), (_vm.AnnexureFilePath != '') ? _c('span', [_vm._v(" \n              "), (_vm.fileExtension == 'png' || _vm.fileExtension == 'jpg' || _vm.fileExtension == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Document"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.AnnexureFilePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileExtension == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.AnnexureFilePath)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "files",
    class: {
      'form-control': true,
      'error': _vm.errors.has('uploadAnnexure')
    },
    attrs: {
      "id": "uploadAnnexure",
      "name": "uploadAnnexure",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChangedForAnnexure
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PDF,PNG, XLS, XLSX, ODS, DOC, DOCX."), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 20MB.\n          ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadAnnexure')),
      expression: "errors.has('uploadAnnexure')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please upload file.")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('br')])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fcb0676","hasScoped":true}!./src/modules/shared/components/Template1/annexures/createAnnexure/createAnnexure.component.html
// module id = 612
// module chunks = 3